import React from 'react';

// tslint:disable:max-line-length
const DuedateCompleteIcon = (props) => (
  <svg width={14} height={14} viewBox="0 0 14 14" {...props}>
    <g fill={props.color || 'currentColor'}>
      <path d="M11.833 7.041a4.79 4.79 0 1 0-9.583 0 4.791 4.791 0 1 0 9.583 0zm1.5 0a6.292 6.292 0 1 1-12.583 0 6.292 6.292 0 0 1 12.583 0z" />
      <path d="M5.062 6.957a.75.75 0 0 0 0 1.5h2.74L7.75 4.101a.75.75 0 1 0-1.5.018l.034 2.838H5.062z" />
    </g>
  </svg>
);
// tslint:enable:max-line-length

export default DuedateCompleteIcon;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/icons/DuedateCompleteIcon.js